export const CHANGE_PAYMENT_ADDRESS_ID = 'CHANGE_PAYMENT_ADDRESS_ID';

export const changeAddressId = (id) => ({
  type: CHANGE_PAYMENT_ADDRESS_ID,
  payload: id
});
